export function showOkDialog(modal, title, message, okCallback?) {
  modal
    .msgBoxOk(message, {
      title: title,
      size: "sm",
      buttonSize: "sm",
      okVariant: "primary",
      okTitle: "Ok",
      footerClass: "p-2",
      hideHeaderClose: true,
      centered: true,
      id: "okDialog",
    })
    .then(() => {
      okCallback?.();
    })
    .catch(() => {
      //console.log("close case error", error);
    });
}

export function showConfirmDialog(modal, title, message, okTitle, confirmCallback) {
  modal
    .msgBoxConfirm(message, {
      title,
      size: "sm",
      buttonSize: "sm",
      okVariant: "primary",
      okTitle,
      footerClass: "p-2",
      hideHeaderClose: true,
      noCloseOnBackdrop: true,
      noCloseOnEsc: true,
      centered: true,
      id: "confirmDialog",
    })
    .then((accepted) => {
      if (accepted) {
        confirmCallback();
      }
    })
    .catch(() => {
      // console.log("logout error", error);
    });
}
